import React, { useState, useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import { onAuthStateChanged } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { auth, firestore } from "./firebase";

import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
// import Services from "./pages/Services";
import Service from "./pages/Service";
import Style from "./pages/Style";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Settings from "./pages/Settings";
import Upload from "./pages/Upload";

import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./components/NotFound";

import {
  Navigate,
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import "./App.scss";

function App() {
  const [signedIn, setSignedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const user = auth.currentUser;
  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        setSignedIn(true);
        // console.log(user);

        const usersRef = collection(firestore, "users");
        const userQuery = query(usersRef, where("email", "==", user.email));

        const querySnapshot = await getDocs(userQuery);

        if (!querySnapshot.empty) {
          const userData = querySnapshot.docs[0].data();
          setIsAdmin(userData.isAdmin);
        } else {
          setIsAdmin(false);
        }
      } else {
        setSignedIn(false);
        setIsAdmin(false);
        console.log("user is logged out");
      }
      setLoading(false);
    });
  }, []);

  const backToClient = () => {
    setIsAdmin(false);
  };

  return (
    <>
      {isAdmin ? (
        <>
          <h1>Hi Admin</h1>
          <h3>Your page is being set up</h3>
          <button className="button" onClick={backToClient}>
            Go back to client?
          </button>
        </>
      ) : (
        <>
          <Router>
            <section className={`loading ${loading ? "visible" : "hidden"}`}>
              <img
                src="https://res.cloudinary.com/qaz2dc/image/upload/v1690305330/ucbraids/UC_Braids_rujwoz.png"
                alt="UC Braids"
              />
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#cd5c5e"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </section>
            <Nav
              signedIn={signedIn}
              profileName={signedIn ? user.displayName : ""}
              avatar={signedIn ? user.photoURL : ""}
            />
            <ScrollToTop />
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/contact" element={<Contact />} />
              {signedIn ? (
                <>
                  <Route
                    path="/login"
                    element={<Navigate to="/" replace />} // Redirect to home if signed in
                  />
                  <Route
                    path="/signup"
                    element={<Navigate to="/" replace />} // Redirect to home if signed in
                  />
                  <Route path="/settings" element={<Settings user={user} />} />
                </>
              ) : (
                <>
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  {/* <Route
                    path="/settings"
                    element={<Navigate to="/" replace />}
                  /> */}
                </>
              )}
              <Route path="/services/:category" element={<Service />} />
              <Route path="/services/:category/:id" element={<Style />} />
              <Route exact path="/upload" element={<Upload />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
          </Router>
        </>
      )}
    </>
  );
}

export default App;
